<template>
  <l-map 
    v-if="centro[0] != 39.4746227" 
    ref="map" 
    v-model:zoom="zoom" 
    :maxZoom="maxZoom" 
    :minZoom="minZoom"
    :center="centro"
    @mousedown="onMapMouseDown"
    @mouseup="onMapMouseUp"
    @move="onMapMove"
  >
    <l-tile-layer  
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
      layer-type="base"
      name="OpenStreetMap">
    </l-tile-layer>
    <l-marker 
      v-if="coordenadas" 
      :lat-lng="coordenadas"
    >
    </l-marker>

    <!-- Marcador rojo para segunda ubicación -->
    <l-marker 
      v-if="coordenadasSegunda" 
      :lat-lng="coordenadasSegunda"
      :icon="iconoRojo"
      @click="eliminarSegunda"
    >
    <l-tooltip>2ª ubicación (agregada por operario)</l-tooltip>
    </l-marker>
  </l-map>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet";
import L from 'leaflet';
import { PwgsApi } from "../../../../../services/PwgsApi";

export default {
  props: ['id', 'servicio', 'datoscliente', 'cliente'],
  components: {
    LTooltip,
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      centro: [39.4746227, -0.3477796],
      coordenadas: '',
      coordenadasSegunda: null,
      zoom: 13,
      iconWidth: 25,
      iconHeight: 40,
      maxZoom: 19,
      minZoom: 2,  
      mapMoved: false,
      iconoRojo: L.icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
    };
  },
  methods: {
    onMapMouseDown() {
      this.mapMoved = false;
    },
    onMapMouseUp(event) {
      if (!this.mapMoved) {
        this.confirmar(event);
      }
    },
    onMapMove() {
      this.mapMoved = true;
    },
    confirmar(event) {
      this.$confirm.require({
        message: '¿Modificar las coordenadas del expediente?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'Cancelar',
        acceptLabel: 'Aceptar',
        accept: () => {
          this.editarCoordenadas(event)
        },
        reject: () => {
          return;
        }
      });        
    },
    async cargarcoordenadas() {
      const datos = this.cliente;
      console.log('datoscliente', datos, this.servicio);
      if (datos != '') {
        setTimeout(() => {
          // Coordenada principal (igual que antes)
          let aux1 = '';
          for (let j = 0; j <= datos.asegurado?.coordenadas.length; j++) {
            if (datos.asegurado?.coordenadas[j] == ",") { 
              aux1 = L.latLng(datos.asegurado?.coordenadas.slice(0, j), datos.asegurado?.coordenadas.slice(j + 1));
            }
          }
          this.coordenadas = aux1;
          this.centro = aux1;

          // Segunda ubicación
          const segunda = this.servicio?.segunda_ubicacion;
          if (segunda && segunda !== '') {
            const commaIndex = segunda.indexOf(',');
            if (commaIndex !== -1) {
              const lat = segunda.slice(0, commaIndex);
              const lng = segunda.slice(commaIndex + 1);
              this.coordenadasSegunda = L.latLng(lat, lng);
            }
          } else {
            this.coordenadasSegunda = null;
          }

        }, 400);
      }
    },
    async editarCoordenadas(event) {
      const { lat, lng } = event.latlng;
      try {
        const api = new PwgsApi();
        var coordenadas = [lat, lng];
        await api.put('servicios/'+this.id+'/modificar-coordenadas', {coordenadas: lat + ',' + lng});
        this.coordenadas = coordenadas;
        this.$toast.add({ severity: 'success', summary: 'Actualizadas', detail: 'Coordenadas actualizadas correctamente', life: 2000 });
      } catch(e) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'e', life: 2000 });
      }
    },
    async eliminarSegunda() {
      this.$confirm.require({
        message: '¿Eliminar la segunda ubicación del expediente?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        rejectClass: 'p-button-secondary p-button-outlined',
        rejectLabel: 'Cancelar',
        acceptLabel: 'Aceptar',
        accept: async () => {
          try {
            const api = new PwgsApi();
            await api.put('servicios/' + this.id + '/modificar-servicio', { segunda_ubicacion: '' });
            this.coordenadasSegunda = null;
            this.$toast.add({ severity: 'success', summary: 'Eliminada', detail: 'Segunda ubicación eliminada correctamente', life: 2000 });
          } catch(e) {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 2000 });
          }
        },
        reject: () => { return; }
      });
    },
    refrescarmapa() {
      document.getElementById(this.$props.id).forceUpdate();
    },
  },
  mounted() { 
    this.cargarcoordenadas();
  },
  watch: {
    cliente() {
      this.$nextTick(() => {
        this.cargarcoordenadas();
      });
    },
    id() {
      this.$nextTick(() => {
        this.cargarcoordenadas();
      });
    },
    ampliarmapa() {}
  }
};
</script>

<style>
.map-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
}
</style>